import gql from 'graphql-tag';

export const TOGGLE_DEFAULT_TABLE_FILTER = gql`
  mutation ToggleDefaultTableFilter($tableFilterId: ID!) {
    tableFilter {
      toggleDefaultTableFilter(tableFilterId: $tableFilterId) {
        success
        error
        entity {
          tableFilterId
          name
          isDefault
          config
        }
      }
    }
  }
`;
